module.exports = __webpack_public_path__ + "static/media/events_cover.afe1c72c.jpg";